export default __webpack_public_path__ + "static/media/gm-sg-girl.af417fe6.webp";